import { USER_ROLES } from "./constants";

interface RouteConfig {
  pathname: string;
  allowedRoles?: string[];
  allowedCountries?: string[];
}

// Route Access Control configuration based on roles.
// Super admin has access to all routes.
// Route is accessible to all logged in admin users if not in this list or allowedRoles is not set.
export const ROUTE_ACL: RouteConfig[] = [
  { pathname: "/" },
  { pathname: "/users", allowedRoles: [USER_ROLES.CUSTOMER_SUPPORT] },
  {
    pathname: "/camp-transactions",
    allowedRoles: [USER_ROLES.CUSTOMER_SUPPORT],
  },
  {
    pathname: "/ledger-activity",
    allowedRoles: [USER_ROLES.CUSTOMER_SUPPORT],
  },
  {
    pathname: "/ledger-balances",
    allowedRoles: [USER_ROLES.CUSTOMER_SUPPORT],
  },
  {
    pathname: "/journal-entries",
    allowedRoles: [USER_ROLES.CUSTOMER_SUPPORT],
    allowedCountries: ["AE"],
  },
];
